import React, { useState } from "react";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import { Box, Heading, Button } from "../../../components/elements";
import { formValidationRules, SuccessToast, SomethingWentWrongToast, Btn } from "../../../components/generalComponets";
import { Post } from "../../../services/services";
import { useForm, Controller } from "react-hook-form";
import { AppInput } from "../../../components/AppInput";
import { SearchPickerHookForm } from "../../../components/SearchPickerHookForm";

export const AddPlan = React.forwardRef(({ customer_types, onSuccess }, ref) => {
  React.useImperativeHandle(ref, () => ({
    onShowModal(userData) {
      setShow(true);
      if (userData && userData.id) {
        setId(userData.id);
        reset(userData);
      } else {
        reset();
        setId(0);
      }
    },
  }));

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    reset,
    control,
    setError,
  } = useForm();
  const [id, setId] = useState(0);
  const [loading, setLoading] = useState(false);

  const onSubmit = (data) => {
    setLoading(true);
    Post("/plan/create", { ...data, id }, (st, res) => {
      setLoading(false);
      if (st && res && res.isSuccess) {
        reset();
        SuccessToast("Plan", id);
        setShow(false);
        if (onSuccess) {
          onSuccess();
        }
      } else if (res && res.errorMessage) {
        if (res.errorCode === "1001") {
          setError("name", { type: "match", message: res.errorMessage });
        }
        toast(res.errorMessage, { type: "error" });
      } else {
        SomethingWentWrongToast();
      }
    });
  };

  const [show, setShow] = useState(false);

  return (
    <Modal show={show}>
      <Box style={{ padding: 16, paddingTop: 0, minWidth: 600 }}>
        <Heading as="h5" className="textAlignLeft" style={{ marginBottom: 16 }}>
          {id ? "Update" : "Add"} Plan
        </Heading>
        <div className="fl">
          <AppInput
            title="Name *"
            inputProps={{ ...register("name", formValidationRules("Name").String100Req) }}
            err={errors.name}
            mr={8}
            maxLength={30}
            show_err_height
            fl
          />
          <AppInput
            title="Description"
            inputProps={{ ...register("description", formValidationRules("Description").String500) }}
            err={errors.description}
            maxLength={100}
            show_err_height
            fl
          />
        </div>

        <div className="fl">
          <AppInput
            title="Rate *"
            inputProps={{ ...register("rate", formValidationRules("Rate").positiveNumberReq) }}
            err={errors.rate}
            mr={8}
            fl
            number
          />
          <Controller
            name="type_id"
            control={control}
            rules={formValidationRules("Type").pickerReq}
            render={({ field }) => (
              <SearchPickerHookForm
                title="Type *"
                err={errors.type_id}
                list={customer_types}
                onChange={(val) => field.onChange(val.id)}
                value={field.value}
                fl
              />
            )}
          />
        </div>
        <Modal.Footer className="alignAllRight">
          <Button type="button" className="btn btn-secondary" onClick={() => setShow(false)}>
            Close
          </Button>
          <Btn wi={120} loading={loading} primary title={"Save"} onClick={handleSubmit(onSubmit)} />
        </Modal.Footer>
      </Box>
    </Modal>
  );
});

AddPlan.displayName = "AddPlan";
